module.exports = __webpack_public_path__ + "img/beijing.f561f522.png";